function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery, useReadQuery, useSuspenseQuery } from "@apollo/client";
import * as Sentry from "@sentry/core";
import { useMemo } from "react";
import { FormProvider } from "react-hook-form";
import { Platform } from "react-native";
import { z } from "zod";
import { flattenErrorMessages } from "@oui/lib/src/flattenErrorMessages";
import { useZodForm } from "@oui/lib/src/form";
import { Button } from "./components/Button/Button";
import { ErrorPresenter } from "./components/ErrorPresenter";
import { View } from "./components/View";
var ErrorResponseSchema = z.discriminatedUnion('__typename', [
    z.object({
        __typename: z.literal('BaseError'),
        message: z.string()
    }),
    z.object({
        __typename: z.literal('SimpleError'),
        message: z.string()
    }),
    z.object({
        __typename: z.literal('ValidationError'),
        message: z.string(),
        fieldErrors: z.array(z.object({
            path: z.array(z.string()),
            message: z.string()
        }))
    })
]);
var SomeErrorSchema = z.object({
    __typename: z.string().refine(function(s) {
        return s.endsWith('Error');
    })
});
function PlatformForm(param) {
    var onSubmit = param.onSubmit, testID = param.testID, children = param.children;
    if (Platform.OS === 'web') {
        return /*#__PURE__*/ _jsx("form", {
            onSubmit: function(e) {
                e.preventDefault();
                onSubmit(e).catch(Sentry.captureException);
            },
            "data-testid": testID,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(View, {
        testID: testID,
        children: children
    });
}
export function Form(param) {
    var testID = param.testID, children = param.children, query = param.query, queryRef = param.queryRef, variables = param.variables, mutate = param.mutate, schema = param.schema, getDefaultValues = param.getDefaultValues, prepareVariables = param.prepareVariables, buttons = param.buttons, onSuccess = param.onSuccess, onError = param.onError, onSave = param.onSave, errorChildren = param.errorChildren, suspense = param.suspense;
    var data = (queryRef ? useReadQuery(queryRef) : query ? suspense ? useSuspenseQuery(query, {
        variables: variables
    }) : useQuery(query, {
        variables: variables
    }) : {
        data: undefined
    }).data;
    var _useMutation = _sliced_to_array(useMutation(mutate), 2), mutation = _useMutation[0], _useMutation_ = _useMutation[1], gqlError = _useMutation_.error, mutationResult = _useMutation_.data;
    var methods = useZodForm(schema, {
        // We lie to the compiler about truthiness so that the suspense version of
        // the callbacks are valid
        defaultValues: getDefaultValues(data)
    });
    var errors = methods.formState.errors, handleSubmit = methods.handleSubmit;
    var onSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(data) {
            var result, _result_data, hasDataError, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            8,
                            ,
                            10
                        ]);
                        return [
                            4,
                            mutation({
                                variables: prepareVariables ? prepareVariables(data) : data
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (!result.data) return [
                            3,
                            7
                        ];
                        hasDataError = !!Object.entries((_result_data = result.data) !== null && _result_data !== void 0 ? _result_data : {}).find(function(param) {
                            var _param = _sliced_to_array(param, 2), _key = _param[0], value = _param[1];
                            return SomeErrorSchema.safeParse(value).success;
                        });
                        if (!hasDataError) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            onError === null || onError === void 0 ? void 0 : onError(data, result.data)
                        ];
                    case 2:
                        _state.sent(); // eslint-disable-line
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data, result.data)
                        ];
                    case 4:
                        _state.sent(); // eslint-disable-line
                        _state.label = 5;
                    case 5:
                        return [
                            4,
                            onSave === null || onSave === void 0 ? void 0 : onSave(data, result.data)
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        return [
                            3,
                            10
                        ];
                    case 8:
                        error = _state.sent();
                        return [
                            4,
                            onError === null || onError === void 0 ? void 0 : onError(data, error)
                        ];
                    case 9:
                        _state.sent(); // eslint-disable-line
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var error = useMemo(function() {
        var maybeResultError = Object.values(mutationResult !== null && mutationResult !== void 0 ? mutationResult : {}).map(function(value) {
            return ErrorResponseSchema.safeParse(value);
        }).find(function(res) {
            return res.success;
        });
        if (maybeResultError === null || maybeResultError === void 0 ? void 0 : maybeResultError.success) {
            return maybeResultError.data;
        }
        return;
    }, [
        mutationResult
    ]);
    var errorMessages = flattenErrorMessages(errors, methods.labels);
    var errorMessage = undefined;
    if (error && 'fieldErrors' in error) {
        // flatten ValidationError.fieldErrors into a single string
        errorMessage = error.fieldErrors.map(function(fieldError) {
            var path = fieldError.path;
            // strip "input" from the path if it's present
            if (path[0] === 'input') {
                path.shift();
            }
            return "".concat(path.join('.'), " ").concat(fieldError.message);
        }).join('\n');
    } else if (error) {
        errorMessage = (error === null || error === void 0 ? void 0 : error.message) || 'An unknown error has occurred.';
    }
    var callbackData = _object_spread_props(_object_spread({}, methods), {
        // We lie to the compiler about truthiness so that the suspense version of
        // the callbacks are valid
        data: data
    });
    buttons = typeof buttons === 'function' ? buttons(callbackData) : buttons;
    return /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, methods), {
        children: /*#__PURE__*/ _jsxs(PlatformForm, {
            onSubmit: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(event) {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    handleSubmit(onSubmit)(event)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            testID: testID,
            children: [
                errorChildren && !!(gqlError || error) ? errorChildren(gqlError || error) // eslint-disable-line
                 : /*#__PURE__*/ _jsx(ErrorPresenter, {
                    formErrors: errorMessages,
                    errorString: errorMessage,
                    error: gqlError
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: {
                        gap: 15
                    },
                    children: children(callbackData)
                }),
                (buttons === null || buttons === void 0 ? void 0 : buttons.hidden) ? null : /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: (buttons === null || buttons === void 0 ? void 0 : buttons.cancel) ? 'space-between' : 'center',
                        paddingTop: 15
                    },
                    children: [
                        (buttons === null || buttons === void 0 ? void 0 : buttons.cancel) && /*#__PURE__*/ _jsx(Button, _object_spread({
                            variant: "text",
                            size: "normal"
                        }, buttons === null || buttons === void 0 ? void 0 : buttons.cancel)),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                gap: 20
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Button, _object_spread({
                                    variant: "solid",
                                    size: "normal",
                                    text: "Save",
                                    onPress: handleSubmit(onSubmit),
                                    type: "submit"
                                }, buttons === null || buttons === void 0 ? void 0 : buttons.submit)),
                                (buttons === null || buttons === void 0 ? void 0 : buttons.skip) && /*#__PURE__*/ _jsx(Button, _object_spread({
                                    variant: "text",
                                    size: "normal"
                                }, buttons === null || buttons === void 0 ? void 0 : buttons.skip))
                            ]
                        })
                    ]
                })
            ]
        })
    }));
}
